export interface ApiAdvParkingLot {
  AdvParkId: string;
  OrganizationId: string;
  Name: string;
  ChannelLimit: string;
  AutoReturnTimeout: string;
  PinRetrievalEnable: string;
  Pin: string;
  ManualReturnEnable: string;
  ManualReturnDtmf: string;
  ReturnAddress?: string;
  MusicSourceId: string;

  AccountId: string;
  AdvParkRetrieverAppId: string;
  AppId: string;
  Created: string;
  Modified: string;
  MusicSourceName: string;
  MusicSourceUrl: string;
  ReturnAddressId: string;
  ReturnAddressUsername: string;
}

export interface AdvParkingLot {
  advParkId: string;
  organizationId: string;
  name: string;
  channelLimit: string;
  autoReturnTimeout: string;
  pinRetrievalEnable: string;
  pin: string;
  manualReturnEnable: string;
  manualReturnDtmf: string;
  returnAddress?: string;
  musicSourceId: string;

  accountId: string;
  advParkRetrieverAppId: string;
  appId: string;
  created: string;
  modified: string;
  musicSourceName: string;
  musicSourceUrl: string;
  returnAddressId: string;
  returnAddressUsername: string;
}

export function apiAdvParkingLotToAdvParkingLot(apiAdvParkingLot: ApiAdvParkingLot): AdvParkingLot {
  return {
    advParkId: apiAdvParkingLot.AdvParkId,
    organizationId: apiAdvParkingLot.OrganizationId,
    name: apiAdvParkingLot.Name,
    channelLimit: apiAdvParkingLot.ChannelLimit,
    autoReturnTimeout: apiAdvParkingLot.AutoReturnTimeout,
    pinRetrievalEnable: apiAdvParkingLot.PinRetrievalEnable,
    pin: apiAdvParkingLot.Pin,
    manualReturnEnable: apiAdvParkingLot.ManualReturnEnable,
    manualReturnDtmf: apiAdvParkingLot.ManualReturnDtmf,
    returnAddress: apiAdvParkingLot.ReturnAddress,
    musicSourceId: apiAdvParkingLot.MusicSourceId,
    accountId: apiAdvParkingLot.AccountId,
    advParkRetrieverAppId: apiAdvParkingLot.AdvParkRetrieverAppId,
    appId: apiAdvParkingLot.AppId,
    created: apiAdvParkingLot.Created,
    modified: apiAdvParkingLot.Modified,
    musicSourceName: apiAdvParkingLot.MusicSourceName,
    musicSourceUrl: apiAdvParkingLot.MusicSourceUrl,
    returnAddressId: apiAdvParkingLot.ReturnAddressId,
    returnAddressUsername: apiAdvParkingLot.ReturnAddressUsername
  };
}

interface ParkParams {
  Name: string;
  Username: string;
  ChannelLimit: string;
  AutoReturnTimeout: string;
  ManualReturnEnable: boolean;
  ManualReturnDtmf: string;
  ReturnAddress?: string;
  MusicSourceId: string;
  UsernameRetriever?: string;
}

interface ParkParamsWithPin extends ParkParams {
  PinRetrievalEnable: true;
  Pin: string;
}

interface ParkParamsWithoutPin extends ParkParams {
  PinRetrievalEnable: false;
}

interface EditParkParamsWithPin extends ParkParamsWithPin {
  AdvParkId: string;
}

interface EditParkParamsWithoutPin extends ParkParamsWithoutPin {
  AdvParkId: string;
}

export type AdvParkingLotParams = ParkParamsWithPin | ParkParamsWithoutPin;

export type EditAdvParkingLotParams = EditParkParamsWithPin | EditParkParamsWithoutPin;
